import { render, staticRenderFns } from "./context-menu-modal.vue?vue&type=template&id=0b50aa0f&"
import script from "./context-menu-modal.vue?vue&type=script&lang=js&"
export * from "./context-menu-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports